import { useMutation } from '@apollo/client';
import { EDIT_PROPERTY_EVENTS } from '@general/graphql/properties.graph';

const useEditPropertyEvents = options => useMutation(EDIT_PROPERTY_EVENTS, options);

export default useEditPropertyEvents;
